<template>
  <div>
    <div v-if="loading">
      <skeleton-revenue />
    </div>
    <div v-else>
      <div class="vuse-content-wrapper mt-4">
        <v-row >
          <v-col cols="12" md="2" class="mt-0">
            <h2 class="ml-3 float-left">
              {{$t(page+'.title')}}
              <!--<span>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">     
                    <v-btn icon color="primary" v-on="on" @click="xmlReport">
                      <v-icon>file_download</v-icon>
                    </v-btn>
                  </template>
                  <span>Download Table as CSV</span>
                </v-tooltip>
              </span>
              -->
            </h2>
          </v-col>
          <v-spacer />
          <!--
          <v-col cols="12" md="8" class="mb-4">  
            <template v-if="user.eBayAccounts">
              <v-btn-toggle
                class="flex-wrap"
                style="background-color:transparent"
                v-model="enabled_eBayAccounts"
                @change="RefreshData()"
                color="primary"
                multiple
                dense

              >
                <template v-for="u in user.eBayAccounts.split(',')">
                  <v-btn class="text-lowercase" :value="u"  :key="u" :small="user.eBayAccounts.split(',').length>8" :x-small="user.eBayAccounts.split(',').length>15">
                    {{u}}
                  </v-btn>
                </template>
              </v-btn-toggle>
            </template>
          </v-col>-->
          <v-col class="text-right" cols="12" md="6">
            <!--
            <v-btn-toggle 
              v-model="timeframe2"
              tile
              color="black"
              group
            
            >
              <v-btn dark @click.stop="setDate(1)"  >
                <v-icon left dark>
                  mdi-calendar
                </v-icon>
                <span>Today</span>
              </v-btn>

              <v-btn dark @click.stop="setDate(7)">
                <v-icon left>
                  mdi-calendar
                </v-icon>
                <span>Last 7 Days</span>
              </v-btn>

              <v-btn dark @click.stop="timeframe_dialog = true" v-if="timeframe">
                <v-icon left dark>
                  mdi-calendar
                </v-icon>
                <span>{{formattedTimeframe}}</span>
              </v-btn>
            </v-btn-toggle>
            -->
            
            <v-btn color="black" class="mr-3" dark @click.stop="setDate(1)" >
              <v-icon left dark>
                mdi-calendar
              </v-icon>
              Yesterday
            </v-btn>
            <v-btn color="black" class="mr-3" dark @click.stop="setDate(7)" >
              <v-icon left dark>
                mdi-calendar
              </v-icon>
              Last 7
            </v-btn>
            <v-btn color="black" class="mr-3" dark @click.stop="setDate(30)" >
              <v-icon left dark>
                mdi-calendar
              </v-icon>
              Last 30
            </v-btn>
            <v-btn color="black" class="mr-3" dark @click.stop="timeframe_dialog = true" v-if="timeframe">
              <v-icon left dark>
                mdi-calendar
              </v-icon>
              {{formattedTimeframe}}
            </v-btn>
            
          </v-col>   
        </v-row>
        <template v-if="errorid=='0001' && !loading">
          <no-data />  
        </template>
        <template v-else> 
          <v-container fluid>
            <v-row class="mt-3" >
              <operational-profit />
              <revenue-cogs />
              <tasks-list />
            </v-row>
            <v-row class="mt-3">
              <ebay-accounts />
              <suppliers-accounts />
              <custom-spends />
            </v-row>
            <basic-stats />
          </v-container>
        </template>
      </div>
    </div>
    <v-dialog v-model="timeframe_dialog" max-width="500">
        <v-card>
          <v-card-title class="text-h5">
            Select Time Frame
          </v-card-title>
          <v-card-text>
            <v-date-picker class="mt-4" v-model="timeframe" :locale="user.locale" range full-width @change="change_timeframe"></v-date-picker>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn dark color="primary" @click="timeframe_dialog = false">
              OK
            </v-btn>
          </v-card-actions>
        </v-card>
    </v-dialog>
    <v-dialog v-model="user.spendmodal" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="text-h5">Enter Custom Spends</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <!--<v-text-field 
                  v-model="CS.description"
                  label="Description" 
                  hint="Enter Same Description to Modify"
                  required>
                </v-text-field>-->
                <!--
    <v-combobox
      v-model="CSDescription"
      :items="user.d_charts.label_expense"
      :search-input.sync="cs_search"
      hide-selected
      hint="Select One Item to Modify or Type new Description to Add"
      label="Expense Description"
      persistent-hint
    >
      <template v-slot:no-data>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              No results matching "<strong>{{ search }}</strong>". Press <kbd>enter</kbd> to create a new one
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-combobox>
-->
              <template v-if="user.d_charts.labels_expense">
                <v-combobox
                  v-model="CS.description"
                  :items="user.d_charts.labels_expense"
                  :search-input.sync="cs_search"
                  hide-selected
                  hint="Select One Item to Modify or Type new Description to Add"
                  label="Expense Description"
                  persistent-hint
                  chips
                >
                  <template v-slot:no-data>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>
                        Press <kbd>enter</kbd> to create "<strong>{{ cs_search }}</strong>" expense.
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-combobox>
              </template>



              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-select
                  v-model="CS.currency"
                  :items="['USD', 'EUR', 'ILS']"
                  value="USD"
                  label="Currency"
                  required
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  v-model="CS.amount"
                  label="Amount"
                  type="number"
                  hint="Periodic Amount"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-select
                  v-model="CS.frequency"
                  :items="[{text:'Monthly', value:1},{text: 'Quarterly', value:3},{text:'Yearly',value:12},{text:'One Shot',value:12000}]"
                  item-text="text"
                  item-value="value"
                  label="Frequency"
                  required
                  value="Monthly"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6">
                <v-menu
                  v-model="menu1"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="CS.datefrom"
                      label="Start Date"
                      hint="DD/MM/YYYY format"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="CS.datefrom" @input="menu1 = false"></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="6">
                <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="CS.dateto"
                      label="Stop Date"
                      hint="DD/MM/YYYY format"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="CS.dateto" @input="menu2 = false"></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="text-left" @click="toggleSpendModalBtn(false)">Close</v-btn
          >
          <v-btn color="primary"  @click="saveSpend">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" absolute top right :color="snackbar_color">
      <span>{{snackbar_text}}</span>
    </v-snackbar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import NoData from "@/components/NoData";
import SkeletonRevenue from "@/components/SkeletonRevenue";
import BasicStats from "./Partials/BasicStats";
import OperationalProfit from "./Partials/OperationalProfit";
import RevenueCogs from "./Partials/RevenueCogs";
import TasksList from "./Partials/TasksList";
import EbayAccounts from "./Partials/EbayAccounts";
import SuppliersAccounts from "./Partials/SuppliersAccounts";
import CustomSpends from "./Partials/CustomSpends";
export default {

  components: {
    SkeletonRevenue,
    BasicStats,
    OperationalProfit,
    RevenueCogs,
    TasksList,
    EbayAccounts,
    SuppliersAccounts,
    CustomSpends,
    NoData,
  },
  computed : {
    ...mapGetters(["user","settings","formattedTimeframe","LOADER"])
  },
  data(){
    return {
      namespace: "Dashboard",
      page: "Dashboard",
      loading: false,
      timeframe: [],
      timeframe_dialog: false,
      errorid: null,
      charts: {},
      c:null,
      menu1:0,
      menu2:0,
      cs_search:null,
      snackbar:false,
      snackbar_text:'',
      snackbar_color:'',
      model:null,
      CS:{
        currency:'USD',
        frequency:'Monthly',
      }
    }
  },
  created(){
    if (this.user.datefrom === undefined)
    {
      console.log('loader',this.user.datefrom);
      this.LOADER;
      console.log('ldr',this.LOADER);
    }
    this.timeframe=[this.user.datefrom,this.user.dateto];
    console.log(this.timeframe);

    this.loadData()
  },
  methods:
  {
    async saveSpend(){
      //console.log(this.CS);
      let jwt=sessionStorage.getItem('jwt');
      this.toggleSpendModalBtn(false)
      //this.loading=true;
      try{
          //let lc=[[colors.red.base,colors.red.lighten3],[colors.pink.base,colors.pink.lighten3],[colors.purple.base,colors.purple.lighten3],[colors.indigo.base,colors.indigo.lighten3],[colors.blue.base,colors.blue.lighten3],[colors.cyan.base,colors.cyan.lighten3],[colors.teal.base,colors.teal.lighten3],[colors.green.base,colors.green.lighten3],[colors.lime.base,colors.lime.lighten3],[colors.yellow.base,colors.yellow.lighten3],[colors.amber.base,colors.amber.lighten3],[colors.orange.base,colors.orange.lighten3],[colors.brown.base,colors.brown.lighten3],[colors.red.lighten3,colors.red.darken3],[colors.pink.lighten3,colors.pink.darken3],[colors.purple.lighten3,colors.purple.darken3],[colors.indigo.lighten3,colors.indigo.darken3],[colors.blue.lighten3,colors.blue.darken3],[colors.cyan.lighten3,colors.cyan.darken3],[colors.teal.lighten3,colors.teal.darken3],[colors.green.lighten3,colors.green.darken3],[colors.lime.lighten3,colors.lime.darken3],[colors.yellow.lighten3,colors.yellow.darken3],[colors.amber.lighten3,colors.amber.darken3],[colors.orange.lighten3,colors.orange.darken3],[colors.brown.lighten3,colors.brown.darken3],[colors.grey.lighten3,colors.grey.darken3]];
          const res = await this.$http.post('/dashboard/savemanualspend.php', {"jwt":jwt,"payload":JSON.stringify(this.CS)});
          //console.log(res);
          switch (res.data.errorid)
          {
            case '0':
              this.snackbar_color='success';
              this.snackbar_text=res.data.payload.message;
            break;

            case '0001':
              this.snackbar_color='error';
              this.snackbar_text=res.data.payload.message;
            break;

            case '0006':
              this.$router.push('/auth/login').catch(() => {});
            break;
          }
          //this.loading= false;

      } catch(e)
      {
          this.loading= false;
          //console.log(res.data);
      }
      //this.loading= false;
      this.loadData();
    },
    toggleSpendModalBtn(v)
    {
      console.log('toggleSpendModal');
      this.$store.dispatch("toggleSpendModal",v); 
    },
    change_timeframe(){
      if (this.timeframe[0]>this.timeframe[1])
      {
        let tmp=this.timeframe[0];
        this.timeframe[0]=this.timeframe[1]
        this.timeframe[1]=tmp;
      }
      this.$store.dispatch("set_timeframe", this.timeframe);  
      this.loadData();
    },
    setDate(dd){
      var date = new Date();
      var y = date.getFullYear();
      var m = date.getMonth();
      var d = date.getDate();
      var k = new Date(y,m,0).getDate();
      var firstDay = dd==30?new Date(y, m, d-k+1):new Date(y, m, d-dd+1);
      var lastDay = new Date(y, m , d+1);

      this.timeframe=[firstDay.toISOString().split('T')[0],lastDay.toISOString().split('T')[0]];      
      console.log('427tf',this.timeframe);
      let ctf=this.timeframe;
      this.$store.dispatch("set_timeframe", ctf);  
      this.loadData();
    },
    async loadData(){
      this.loading=true;
      try{
          //let lc=[[colors.red.base,colors.red.lighten3],[colors.pink.base,colors.pink.lighten3],[colors.purple.base,colors.purple.lighten3],[colors.indigo.base,colors.indigo.lighten3],[colors.blue.base,colors.blue.lighten3],[colors.cyan.base,colors.cyan.lighten3],[colors.teal.base,colors.teal.lighten3],[colors.green.base,colors.green.lighten3],[colors.lime.base,colors.lime.lighten3],[colors.yellow.base,colors.yellow.lighten3],[colors.amber.base,colors.amber.lighten3],[colors.orange.base,colors.orange.lighten3],[colors.brown.base,colors.brown.lighten3],[colors.red.lighten3,colors.red.darken3],[colors.pink.lighten3,colors.pink.darken3],[colors.purple.lighten3,colors.purple.darken3],[colors.indigo.lighten3,colors.indigo.darken3],[colors.blue.lighten3,colors.blue.darken3],[colors.cyan.lighten3,colors.cyan.darken3],[colors.teal.lighten3,colors.teal.darken3],[colors.green.lighten3,colors.green.darken3],[colors.lime.lighten3,colors.lime.darken3],[colors.yellow.lighten3,colors.yellow.darken3],[colors.amber.lighten3,colors.amber.darken3],[colors.orange.lighten3,colors.orange.darken3],[colors.brown.lighten3,colors.brown.darken3],[colors.grey.lighten3,colors.grey.darken3]];
          const res = await this.$http.post('/dashboard/dashboard.php', {"timeframe":this.timeframe.toString()});
          //console.log(res);
          console.log('dash440',this.user);
          switch (res.data.errorid)
          {
            case '0':
              sessionStorage.setItem('jwt', res.data.jwt);
              this.$store.dispatch("setDashboardCharts", res.data.payload); 
              console.log(res.data.payload);
            break;

            case '0001':
              this.data.datasets[0].data = res.data.payload.data0;
              this.data.datasets[1].data = res.data.payload.data1;
              this.data.datasets[2].data = res.data.payload.data1;
              this.data.datasets[3].data = res.data.payload.data1;
              this.data.labels = res.data.payload.labels; 
              //this.LineChart.update();
            break;

            case '0006':
              this.$router.push('/auth/login').catch(() => {});
            break;
          }
          this.loading= false;

      } catch(e)
      {
          this.loading= false;
          //console.log(res.data);
      }
    },
  },
  watch: {
      model (val) {
        if (val.length > 5) {
          this.$nextTick(() => this.model.pop())
        }
      },
    },
};
</script>
